import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import List from './list';
import { generalClasses as styles } from './styles';

const BranchOffice = props => {
  const { classes } = props;

  return (
    <Card className={classes.card}>
      <CardHeader title="Sucursales" />
      <CardContent className={classes.cardContent}>
        <List />
      </CardContent>
    </Card>
  );
};

export default withStyles(styles)(BranchOffice);
